import React, { useState, useEffect } from 'react'
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import FormAction from './formAction'
import Select from "react-dropdown-select";
import { Country } from 'country-state-city'

function ContactInfo (props){

  const allCountries = Country.getAllCountries();
  const [state, setState] = useState({
    formData: {
      percent_completed: 20,
      mailing_address_1: '',
      mailing_address_2: '',
      city: '',
      country: '',
      state: '',
      zip_code: '',
      primary_phone_no: '',
      alternate_phone_no: '',
      preference_of_contact: ''
    },
    mailing_address_1Valid: '',
    cityValid: '',
    countryValid: '',
    stateValid: '',
    zip_codeValid: '',
    primary_phone_noValid: '',
    isFormDataValid: false
  })

  const listOfContactPreferences = [
    {
      id: 1,
      name: 'Email',
      value: 'email',
      label: 'Email',
    },
    {
      id: 2,
      name: 'Text',
      value: 'text',
      label: 'Text',
    },
    {
      id: 3,
      name: 'Call',
      value: 'call',
      label: 'Call',
    }
  ];

  const { savedSteps, selectedProgramId, selectedProgramLabel } = useSelector((state) => ({
    savedSteps: state.applicationReducer.savedSteps,
    selectedProgramId: state.applicationReducer.selectedProgramId,
    selectedProgramLabel: state.applicationReducer.selectedProgramLabel
  }), shallowEqual);


  useEffect(()=>{
    window.scrollTo(0, 0)
    if (!!savedSteps.contactInfo) {
      populateForm();
    } else if (!!savedSteps.loggedOutUserInfo && !savedSteps.contactInfo){
      prePopulateForm();
    }
  },[])

  useEffect(()=>{
    validateForm();
  },[state])

  function prePopulateForm() {
    const loggedOutData = savedSteps.loggedOutUserInfo;
    if (Object.keys(loggedOutData).length > 0) {
      updateForm('primary_phone_no', loggedOutData.phone_number)
    }
  }


  function populateForm(){
    const contactInfoData = savedSteps.contactInfo;
    if (!!savedSteps.contactInfo && Object.keys(contactInfoData).length > 0) {
      updateForm('mailing_address_1', contactInfoData.mailing_address_1)
      updateForm('mailing_address_2', contactInfoData.mailing_address_2)
      updateForm('city', contactInfoData.city)
      updateForm('country', contactInfoData.country)
      updateForm('state', contactInfoData.state)
      updateForm('zip_code', contactInfoData.zip_code)
      updateForm('primary_phone_no', contactInfoData.primary_phone_no)
      updateForm('alternate_phone_no', contactInfoData.alternate_phone_no)
      updateForm('preference_of_contact', contactInfoData.preference_of_contact)
    }
  }

  const updateForm = (field, value) => {
    let temp = state.formData
    temp[field] = value
    setState(prevState => ({ ...prevState, formData: temp }));
    _validate(field)
  }
  const _validate = (field) => {
    let regex, valid;
    let value = state.formData[field];
    switch(field){
      case 'mailing_address_2': case 'alternate_phone_no': case 'preference_of_contact':
        valid = true;
        break;
      case 'mailing_address_1': case 'city' : case 'state': case 'country':
        regex = /^.{2,}/;
        valid = regex.test(value)
        break;
      case 'primary_phone_no':
        regex = /^.{10,}/;
        valid = regex.test(value)
        break;
      case 'zip_code':
        regex = /^.{4,}/;
        valid = regex.test(value)
        break;
    }
    setState(prevState => ({ ...prevState, [field+"Valid"]: valid }));
  }

  const validateForm = () => {
    let formData = state
    let form = !!formData.mailing_address_1Valid && !!formData.cityValid && !!formData.countryValid && !!formData.stateValid && !!formData.zip_codeValid && !!formData.primary_phone_noValid
    if (state.isFormDataValid != form) {
      setState(prevState => ({ ...prevState, isFormDataValid: form }));
    }
  }

  const handleSetContactPreference = (contactMode) => {
    updateForm("preference_of_contact", contactMode.value)
  }

  return(
    <>
      	<div className="app-form-container">
      		<div className="main-heading bayan-main-heading">
            {selectedProgramLabel}
          </div>
          <div className="sub-heading app-info">
            Contact Information
          </div>

          <div className="input-group">
            <div className="field-label">Current Mailing Address, Line 1</div>
            <input type='text' className={(state.mailing_address_1Valid === false) ? 'error' : ''} value={state.formData.mailing_address_1} placeholder='Enter Address' onChange={(e)=>{updateForm('mailing_address_1', e.target.value)}} />
            {(state.mailing_address_1Valid === false) && <div className="field-error">Must enter Address.</div>}
          </div>
          <div className="input-group">
            <div className="field-label">Current Mailing Address, Line 2(Optional)</div>
            <input type='text' value={state.formData.mailing_address_2} placeholder='Enter Address' onChange={(e)=>{updateForm('mailing_address_2', e.target.value)}} />
          </div>
          <div className="input-group">
            <div className="field-label">City</div>
            <input type='text' className={(state.cityValid === false) ? 'error' : ''} value={state.formData.city} placeholder='Enter City' onChange={(e)=>{updateForm('city', e.target.value)}} />
            {(state.cityValid === false) && <div className="field-error">Must enter City.</div>}
          </div>

          <div className="row">
            <div className="col col-8">
              <div className="input-group">
                <div className="field-label">State</div>
                <input type='text' value={state.formData.state} placeholder='Enter State' onChange={(e)=>{updateForm('state', e.target.value)}} />
                {(state.stateValid === false) && <div className="field-error">Must enter State.</div>}
              </div>
            </div>
            <div className="col col-4">
              <div className="input-group">
                <div className="field-label">Zipcode</div>
                <input type='text' className={state.formData.zip_codeValid === false ? 'error' : ''} value={state.formData.zip_code} placeholder='Enter Zipcode' onChange={(e)=>{updateForm('zip_code', e.target.value)}} />
                {(state.zip_codeValid === false) && <div className="field-error">Must enter Zipcode.</div>}
              </div>
            </div>
          </div>

          <div className="input-group">
            <div className="field-label">Country</div>
            {/* <input type='text' className={(state.countryValid === false) ? 'error' : ''} value={state.formData.country} placeholder='Enter Country' onChange={(e)=>{updateForm('country', e.target.value)}} /> */}
            <select placeholder="Select your Country" value={state.formData.country} onChange={(e)=>{updateForm('country', e.target.value)}}>
                <option value="">Select Country</option>
                {allCountries.map(country => {
                  return <option key={country.sortname} value={country.sortname}>{country.name}</option>
                })}
              </select>
            {(state.countryValid === false) && <div className="field-error">Must enter Country.</div>}
          </div>

          <div className="row">
            <div className="col col-6">
              <div className="input-group">
                <div className="field-label">Primary Phone Number</div>
                <input type='number' className={state.formData.primary_phone_noValid === false ? 'error' : ''} value={state.formData.primary_phone_no} placeholder='Enter Number' onChange={(e)=>{updateForm('primary_phone_no', e.target.value)}} />
                {(state.primary_phone_noValid === false) && <div className="field-error">Must enter Phone Number.</div>}
              </div>
            </div>
            <div className="col col-6">
              <div className="input-group">
                <div className="field-label">Alternate Phone Number (Optional)</div>
                <input type='number' value={state.formData.alternate_phone_no} placeholder='Enter Number' onChange={(e)=>{updateForm('alternate_phone_no', e.target.value)}} />
              </div>
            </div>
          </div>

          <div className="input-group">
            <div className="field-label">Preferred Mode of Contact (Optional)</div>
            <Select
							options={listOfContactPreferences}
							multi={false}
							placeholder="Select Preferred Mode of Contact"
							dropdownGap={3}
							className={`program-dropdown select-field-program select-contact-pref ${!!state.formData.preference_of_contact ? 'contact-pref-selected' : ''}`}
							dropdownHeight="300px"
							style={{background: '#F2F2F2 0% 0% no-repeat padding-box'}}
							onChange={(values) => handleSetContactPreference(values[0])}
              searchable={false}
              values={state.formData.preference_of_contact ? [listOfContactPreferences.find(opt => opt.value === state.formData.preference_of_contact)]: []}
            />
          </div>


          <FormAction
            isFormDataValid={state.isFormDataValid}
            formData={state.formData}
            formStep={'contactInfo'}
            backStep={'applicantInfo'}
            nextStep={'residency'}
          />
      	</div>
    </>
    );
  }

export default ContactInfo;
